import QrHandler from './QrHandler';

export default QrHandler;
